import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';

  path = pagination_params(params);

  params.Codigo && (path = `${path !== '' ? `${path}&` : ''}Codigo=${params.Codigo}`);
  params.Usuario && (path = `${path !== '' ? `${path}&` : ''}Usuario=${params.Usuario}`);
  params.Nombre && (path = `${path !== '' ? `${path}&` : ''}Nombre=${params.Nombre}`);
  params.Apellido && (path = `${path !== '' ? `${path}&` : ''}Apellido=${params.Apellido}`);
  params.Activo && (path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`);
  params.RolUsuario && (path = `${path !== '' ? `${path}&` : ''}RolUsuario=${params.RolUsuario}`);
  params.Fullname && (path = `${path !== '' ? `${path}&` : ''}Fullname=${params.Fullname}`);

  return path;
};
